import React from 'react';
import { Modal } from 'react-bootstrap';
import PersonaDetails from './PersonaDetails';
import './ProfileModal.css';

function ProfileModal({ show, handleClose, dni }) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      fullscreen="sm-down"
      dialogClassName="profile-modal-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>Perfil Completo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PersonaDetails dni={dni} />
      </Modal.Body>
    </Modal>
  );
}

export default ProfileModal;
